// extracted by mini-css-extract-plugin
export default {"container":"borderedSection_container__4b2fN","label":"borderedSection_label__xMJKS","labelText":"borderedSection_labelText__vAB5I"};